export const pagesTranslations = {
  // News Page
  'news.title': {
    ru: 'Новости',
    kz: 'Жаңалықтар',
    en: 'News'
  },
  'news.subtitle': {
    ru: 'Актуальные новости и объявления',
    kz: 'Өзекті жаңалықтар мен хабарландырулар',
    en: 'Latest news and announcements'
  },
  'news.learnMore': {
    ru: 'Узнать больше',
    kz: 'Көбірек білу',
    en: 'Learn More'
  },
  'news.back': {
    ru: 'Назад',
    kz: 'Артқа',
    en: 'Back'
  },
  'news.publishDate': {
    ru: 'Дата публикации: 25 мая 2025 г.',
    kz: 'Жариялау күні: 25 мамыр 2025 ж.',
    en: 'Publication date: May 25, 2025'
  },
  'news.presidential.title': {
    ru: 'В Казахстане стартует очередной отбор в Президентский молодежный кадровый резерв',
    kz: 'Қазақстанда Президенттік жастар кадр резервіне кезекті іріктеу басталады',
    en: 'Kazakhstan launches another selection for the Presidential Youth Personnel Reserve'
  },
  'news.presidential.content': {
    ru: `⚜️С целью выявления и привлечения талантливой молодежи в систему государственного управления в текущем году пройдет очередной отбор в Президентский молодежный кадровый резерв.

📑 С 1 июня на сайте pkrezerv.gov.kz начнется прием заявок в Президентский молодежный кадровый резерв. 

📩Прием документов продлится до 30 июня текущего года. 

📈Принять участие в отборе могут граждане Республики Казахстан не старше 35 лет, с высшим образованием, владеющие государственным языком c сертификатом не ниже уровня B1 и общим стажем работы не менее 5 лет.

🔗Отбор состоит из 6 этапов:

- Подача документов кандидатов;
- Оценка способности работать с текстовой и числовой информацией;
- Решение ситуационных задач;
- Оценка компетенций;
- Собеседование с кандидатами в Экспертной комиссии по отбору в Резерв;
- Рассмотрение на заседании Национальной комиссии кандидатов, рекомендованных 

📌Экспертной комиссией по итогам в Резерв будут зачислены 50 человек.`,
    kz: `⚜️Мемлекеттік басқару жүйесі үшін талантты жастарды анықтау және тарту мақсатында биыл елімізде Президенттік жастар кадр резервіне кезекті іріктеу өтеді.

📩Іріктеуге өтінімдерді қабылдау 1 маусымнан бастап pkrezerv.gov.kz сайтында қолжетімді болады. 

📨Құжаттар 30 маусымға дейін қабылданады.

📈Іріктеуге жасы 35-тен аспаған, жоғары білімі және 5 жыл жалпы жұмыс тәжірибесі бар, В1 деңгейінен төмен емес сертификаты бар мемлекеттік тілді меңгерген Қазақстан Республикасының азаматы қатыса алады.

🔗Іріктеу 6 кезең бойынша өткізіледі:

– Кандидаттардың құжаттарын қабылдау;
– Мәтіндік және сандық ақпаратпен жұмыс істеу қабілетін бағалау;
– Ситуациялық тапсырмаларды шешу;
– Құзыреттерді бағалау;
– Резервке іріктеу жөніндегі сарапшылық комиссияда кандидаттармен әңгімелесу;
– Сарапшылық комиссия ұсынған кандидаттарды Ұлттық комиссияның отырысында қарау.

📌 Іріктеу қорытындысы бойынша 50 адам Резервке қабылданады.`,
    en: `⚜️In order to identify and attract talented youth to the public administration system, another selection for the Presidential Youth Personnel Reserve will be held this year.

📑 From June 1, applications for the Presidential Youth Personnel Reserve will begin to be accepted on the website pkrezerv.gov.kz.

📩Document acceptance will last until June 30 of this year.

📈Citizens of the Republic of Kazakhstan under 35 years of age, with higher education, proficient in the state language with a certificate not lower than B1 level and with at least 5 years of total work experience can participate in the selection.

🔗The selection consists of 6 stages:

- Submission of candidate documents;
- Assessment of ability to work with textual and numerical information;
- Solving situational tasks;
- Competency assessment;
- Interview with candidates in the Expert Commission for Reserve Selection;
- Consideration at the meeting of the National Commission of candidates recommended

📌50 people will be enrolled in the Reserve based on the results of the Expert Commission.`
  },

  // Presidential Address Page
  'presidential.title': {
    ru: 'Послание Президента Республики Казахстан',
    kz: 'Қазақстан Республикасы Президентінің Жолдауы',
    en: 'Address of the President of the Republic of Kazakhstan'
  },
  'presidential.subtitle': {
    ru: 'Ежегодное обращение Президента к народу Казахстана',
    kz: 'Президенттің Қазақстан халқына жыл сайынғы үндеуі',
    en: 'Annual address of the President to the people of Kazakhstan'
  },
  'presidential.image_alt': {
    ru: 'Президент Республики Казахстан',
    kz: 'Қазақстан Республикасының Президенті',
    en: 'President of the Republic of Kazakhstan'
  },
  'presidential.image_caption': {
    ru: 'Президент Республики Казахстан Касым-Жомарт Токаев',
    kz: 'Қазақстан Республикасының Президенті Қасым-Жомарт Тоқаев',
    en: 'President of the Republic of Kazakhstan Kassym-Jomart Tokayev'
  },

  // Management Page
  'management.title': {
    ru: 'Управленческий персонал центра',
    kz: 'Орталықтың басқару құрамы',
    en: 'Management staff of the center',
  },
};
